<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <f7-block>
    <p>Muestra una lista de datos complementarios de una entidad</p>
    <div class="display-flex justify-content-center">
      <UCSupplementaryData
        :activo="true"
        :entidad-seleccionada="{ Id: 1007 }"
        tipo-entidad-seleccionada="LineaPedidoVenta"
      />
    </div>
  </f7-block>
</template>

<script>
import UCSupplementaryData from '@/components/common/UCSupplementaryData.vue';

export default {
  name: 'TestUCSupplementaryData',
  components: {
    UCSupplementaryData,
  },
};
</script>
